import { TrackingHelper } from './helper';
import { addClickEventListener } from '../util/event';

const DATALAYER_TRACK_TEASER_CLICK_SELECTOR = '.js-datalayer-track-teaser-click';
const DATALAYER_TRACK_SERVICES_SELECTED_SELECTOR = '.js-datalayer-finish-services-selected';
const DATALAYER_TRACK_FINISH_ECOMMERCE_SELECTOR = '.js-datalayer-finish-ecommerce';
const DATALAYER_TRACK_FINISH_TRANSACTION_SELECTOR = '.js-datalayer-finish-transaction';

export function createDataLayerListeners(): void {
    createTeaserClickListeners();
}

/**
 * The order of the commands is important. (#1,#2,#3)
 * The ServicesSelected event must ALWAYS be triggered first. Only then can further events be triggered.
 */
export function createFinishDataLayerEvents(): void {
    createServicesSelectedEvent(); // #1
    createFinishEcommerceEvent(); // #2
    createFinishTransactionEvent(); // #2
}

function createTeaserClickListeners(): void {
    document.querySelectorAll(DATALAYER_TRACK_TEASER_CLICK_SELECTOR).forEach((object: Element) =>
        addClickEventListener(object, () =>
            TrackingHelper.trackProductClick({
                id: (<HTMLElement>object).dataset.datalayerId || '',
                name: (<HTMLElement>object).dataset.datalayerName || '',
                price: (<HTMLElement>object).dataset.datalayerPrice || '',
                brand: (<HTMLElement>object).dataset.datalayerOrganizer || '',
            })
        )
    );
}

function createServicesSelectedEvent(): void {
    const object: Element|null = document.querySelector(DATALAYER_TRACK_SERVICES_SELECTED_SELECTOR);

    if (!object) {
        return;
    }

    TrackingHelper.trackSelectedServices((<HTMLElement>object).dataset.storageKey || '');
}

function createFinishEcommerceEvent(): void {
    const object: Element|null = document.querySelector(DATALAYER_TRACK_FINISH_ECOMMERCE_SELECTOR);

    if (!object) {
        return;
    }

    TrackingHelper.trackFinishEcommerce(
        (<HTMLElement>object).dataset.eventData || ''
    )
}

function createFinishTransactionEvent(): void {
    const object: Element|null = document.querySelector(DATALAYER_TRACK_FINISH_TRANSACTION_SELECTOR);

    if (!object) {
        return;
    }

    TrackingHelper.trackFinishTransaction(
        {
            transactionId: (<HTMLElement>object).dataset.transactionId || '',
            transactionAffiliation: (<HTMLElement>object).dataset.transactionAffiliation || '',
            transactionTotal: parseInt((<HTMLElement>object).dataset.transactionTotal || '0', 10),
            transSku: (<HTMLElement>object).dataset.transSku || '',
            transName: (<HTMLElement>object).dataset.transName || '',
            transCategory: (<HTMLElement>object).dataset.transCategory || '',
            transPrice: parseInt((<HTMLElement>object).dataset.transPrice || '0', 10),
            quantity: (<HTMLElement>object).dataset.quantity || '',
            isBinding: (<HTMLElement>object).dataset.isBinding || false,
            appointmentId: (<HTMLElement>object).dataset.appointmentId || '',
            bookingId: parseInt((<HTMLElement>object).dataset.bookingId || '0')
        }
    )
}
